import styled from "styled-components";
import { COLORS } from "../../../../../styles/constants.style";

export const POTransactionsWrapper = styled.div`
  .MuiTable-root .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root {
    .positive-sign {
      margin-left: 5px;
      display: inline-block;
      color: ${COLORS.cirrus_green};
    }
    .negative-sign {
      margin-left: 5px;
      display: inline-block;
      color: ${COLORS.cirrus_red};
    }
    .cell-line-of-business {
      min-width: 200px;
    }
  }
`;
